import type { DocsManifest } from "./types";

export async function fetchDocsManifest(): Promise<DocsManifest> {
	const res = await fetch("/docs/manifest.json");
	if (!res.ok) throw new Error("Failed to load docs manifest");
	return res.json() as Promise<DocsManifest>;
}

export async function fetchDocsArticle(
	sectionId: string,
	slug: string,
): Promise<string> {
	const res = await fetch(`/docs/${sectionId}/${slug}.md`);
	if (!res.ok) throw new Error(`Docs page not found: ${sectionId}/${slug}`);
	return res.text();
}
